<div class="agmo-breadcrumb">
    <ng-template ngFor let-route [ngForOf]="routes" let-last="last">
        <div [routerLink]="getRouteUrl(route)" [ngClass]="last ? 'active' : 'link'">{{getRouteTitle(route)}}</div>
        <div class="icon" [hidden]="last"><i class="fas fa-angle-right"></i></div>
    </ng-template>
</div>
